// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"316":"5afd4063","453":"28f1417b","455":"4bbd623a","644":"ada3bcb6","868":"edad92a8","977":"b1e6443f"}[chunkId] + ".chunk.js";
};